import { Component } from "react";

// Red de seguridad para el modal de FaceHeart: el SDK manipula el DOM
// directamente y puede provocar errores de reconciliación de React
// (ej. "insertBefore NotFoundError") al cerrar/limpiar. Esta barrera evita
// que ese error propague y deje la pantalla en blanco; cierra el modal limpio.
export class VitalsErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    console.warn("[VitalsErrorBoundary] Error contenido (SDK/DOM):", error?.message, info);
    if (this.props.onError) this.props.onError(error);
  }
  render() {
    if (this.state.hasError) return null;
    return this.props.children;
  }
}
